import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class UrlService {
    private history: string[] = [];
    previousUrl: string;
    currentUrl: string;
    constructor(
        private router: Router,
        private location: Location
    ) {
        this.currentUrl = this.router.url;
        router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
                this.history.push(event.urlAfterRedirects);
            }
        });
    }

    public getPreviousUrl() {
        return this.previousUrl;
    }

    navigateBack() {
        if (this.previousUrl === this.currentUrl) {
            //this.router.navigate(["/home"])
        } else {
            //this.router.navigate([this.getPreviousUrl()])
        }
    }

    back(): void {
        this.history.pop();
        if (this.history.length > 0) {
            this.location.back();
        } else {
            this.router.navigateByUrl('/home');
        }
    }
}
